export { NearbySchoolsModule } from './NearbySchoolsModule';
export {
  buildAllTabOrdering,
  computeNearestSchools,
  getGradeRange,
  getSchoolTypeLabel,
  groupSchoolsByType,
  hasNearbySchoolsData,
} from './schoolUtils';
